// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : Removed the unused 'line' and 'AutoLoan Index'
// MODFIED DATA : 01-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import PreCloseLoanActionTypes from './pre-close-loan.types';
import {
	preCloseLoanMemberListGet,
	PreCloseLoanMemberListUpdate,
	PreCloseLoanMemberListRevert,
	BranchEODDetails,
} from './pre-close-loan.service';
import {
	fetchPreCloseLoanListSuccess,
	fetchPreCloseLoanListFailure,
	fetchPreCloseLoanListResponseChanged,
	updatePreCloseLoanDetailsSuccess,
	updatePreCloseLoanDetailsFailure,
	updatePreCloseLoanDetailsChanged,
	revertPreCloseLoanDetailsSuccess,
	revertPreCloseLoanDetailsFailure,
	revertPreCloseLoanDetailsChanged,
	getBranchEODSuccess,
	getBranchEODFailure,
	getBranchEODChanged,
} from './pre-close-loan.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET Close Loan MEMBER REPORT DETAILS  ******************** */
export function* getcloseLoanMemberList({ payload }: any) {
	try {
		const key = 'fetchPreCloseMemberListKey';
		const {
			companyID,
			branchID,
			centerID,
			groupID,
			databaseName,
			userID,
			preCloseDate,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			UserID: userID,
			PrecloseDate: preCloseDate,
			LoanIndexType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(preCloseLoanMemberListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPreCloseLoanListFailure(responseData.data));
		} else {
			yield put(fetchPreCloseLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPreCloseLoanListFailure(error));
	}
}

export function* resetGetPreCloseLoanResponse() {
	yield put(fetchPreCloseLoanListResponseChanged());
}

export function* onGetPreCloseLoanDetails() {
	yield takeLatest(
		PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_START,
		getcloseLoanMemberList,
	);
}

export function* onGetPreCloseLoanResponseReset() {
	yield takeLatest(
		PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_RESPONSE_RESET,
		resetGetPreCloseLoanResponse,
	);
}
/** *********************  END GET PreCloseLoan MEMBER REPORT LIST ******************** */

/** *********************  START UPDATE Close Loan MEMBER REPORT DETAILS  ******************** */
export function* updatecloseLoanMemberList({ payload }: any) {
	try {
		const key = 'updatePreCloseMemberDetailKey';
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			userLevel,
			infogID,
			branchID,
			CenterID,
			centerName,
			groupID,
			databaseName,
			preclosedate,
			preCloseDateUI,
			precloseCollectAll,
			accountArr,
			selectLoanTab,
			preCloseList,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			UserLevel: userLevel,
			InfogCompanyID: infogID,
			BranchID: branchID,
			CenterID,
			CenterName: centerName,
			GroupID: groupID,
			DatabaseName: databaseName,
			CreatedFor: userID,
			Preclosedate: preclosedate,
			PreCloseDateUI: preCloseDateUI,
			PrecloseCollectAll: precloseCollectAll,
			PreCloseList: JSON.stringify(preCloseList).replace(/"/g, "'"),
			AccountArr: accountArr,
			LoanIndexType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PreCloseLoanMemberListUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePreCloseLoanDetailsFailure(responseData.data));
		} else {
			yield put(updatePreCloseLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePreCloseLoanDetailsFailure(error));
	}
}

export function* resetUpdatePreCloseLoanResponse() {
	yield put(updatePreCloseLoanDetailsChanged());
}

export function* onUpdatePreCloseLoanDetails() {
	yield takeLatest(
		PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_START,
		updatecloseLoanMemberList,
	);
}

export function* onUpdatePreCloseLoanResponseReset() {
	yield takeLatest(
		PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_RESET,
		resetUpdatePreCloseLoanResponse,
	);
}
/** *********************  END UPDATE PreCloseLoan MEMBER REPORT LIST ******************** */

/** *********************  START REVERT Close Loan MEMBER REPORT DETAILS  ******************** */
export function* revertcloseLoanMemberList({ payload }: any) {
	try {
		const key = 'revertPreCloseMemberDetailKey';
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			userLevel,
			branchID,
			CenterID,
			centerName,
			groupID,
			databaseName,
			selectLoanTab,
			infogCompanyID,
			preCloseDate,
			revertData,
		} = payload;
		const {
			LoanIndexID,
			LoanIndexGroupMemberID,
			BranchCashAccountID,
			MemberID,
			BranchBankAccountID,
			FunderID,
			FunderPrincipalAccountID,
			FunderInterestAccountID,
			TotalPreClosePrincipal,
			TotalPreCloseInterest,
			memberSavingAccID,
			positiveAmountDiff,
			lastInsertTransactionID,
		} = revertData;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			UserLevel: userLevel,
			InfogID: infogCompanyID,
			BranchID: branchID,
			CenterID: CenterID,
			CenterName: centerName,
			GroupID: groupID,
			DatabaseName: databaseName,
			CreatedFor: userID,
			PrecloseDate: preCloseDate,
			LoanIndexID,
			LoanIndexGroupMemberID,
			MemberID,
			BranchCashAccountID,
			BranchBankAccountID,
			FunderID,
			FunderPrincipalAccountID,
			FunderInterestAccountID,
			PreclosePrincipal: TotalPreClosePrincipal,
			PrecloseInterest: TotalPreCloseInterest,
			memberSavingAccID,
			positiveAmountDiff,
			lastInsertTransactionID,
			LoanIndexType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PreCloseLoanMemberListRevert, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertPreCloseLoanDetailsFailure(responseData.data));
		} else {
			yield put(revertPreCloseLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertPreCloseLoanDetailsFailure(error));
	}
}

export function* resetRevertPreCloseLoanResponse() {
	yield put(revertPreCloseLoanDetailsChanged());
}

export function* onRevertPreCloseLoanDetails() {
	yield takeLatest(
		PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_START,
		revertcloseLoanMemberList,
	);
}

export function* onRevertPreCloseLoanResponseReset() {
	yield takeLatest(
		PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_RESET,
		resetRevertPreCloseLoanResponse,
	);
}
/** *********************  END REVERT PreCloseLoan MEMBER REPORT LIST ******************** */

/** *********************  START GET Close Loan MEMBER REPORT DETAILS  ******************** */
export function* getBranchEODDetailsStart({ payload }: any) {
	try {
		const key = 'getBranchEODExistPreCloseDetailsKey';
		const {
			companyID,
			userID,
			branchID,
			groupID,
			databaseName,
			selectLoanTab,
			centerID,
			collectionDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			UserID: userID,
			InputDate: collectionDate,
			LoanIndexType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchEODDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchEODFailure(responseData.data));
		} else {
			yield put(getBranchEODSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchEODFailure(error));
	}
}

export function* resetBranchEODDetails() {
	yield put(getBranchEODChanged());
}

export function* onGetBranchEODDetails() {
	yield takeLatest(PreCloseLoanActionTypes.GET_BRANCH_EOD_START, getBranchEODDetailsStart);
}

export function* onGetBranchEODResponseReset() {
	yield takeLatest(PreCloseLoanActionTypes.GET_BRANCH_EOD_RESET, resetBranchEODDetails);
}
/** *********************  END GET PreCloseLoan MEMBER REPORT LIST ******************** */

export function* preCloseLoanMemberSaga() {
	yield all([
		call(onGetPreCloseLoanDetails),
		call(onGetPreCloseLoanResponseReset),
		call(onUpdatePreCloseLoanDetails),
		call(onUpdatePreCloseLoanResponseReset),
		call(onRevertPreCloseLoanDetails),
		call(onRevertPreCloseLoanResponseReset),
		call(onGetBranchEODDetails),
		call(onGetBranchEODResponseReset),
	]);
}
